import logoUrl from './brand/logo.png';

/**
 * The WyoCSPay logo.
 *
 * The artwork is the supplied WyoCSPay master, downscaled for the application
 * bundle so it stays crisp on high-density screens without shipping the full
 * source image to every page load. Rendered height is fixed
 * and the width follows, so the file's own dimensions never leak into the
 * layout.
 *
 * The artwork includes its own dark contour and remains legible on both the
 * panel-blue headers and the merchant sidebar. Do not add CSS filters or alter
 * the supplied colours.
 *
 * Bundled through the app rather than fetched from a URL: the payment page's
 * Content-Security-Policy is `default-src 'none'` with `img-src 'self'`, and a
 * bundled asset is same-origin.
 */

export interface LogoProps {
  /** Rendered height in pixels. Width follows the artwork's aspect ratio. */
  height?: number;
  title?: string;
  className?: string;
}

export function Logo({ height = 56, title = 'WyoCSPay', className }: LogoProps) {
  return (
    <img
      src={logoUrl}
      alt={title}
      className={className}
      height={height}
      style={{ height, width: 'auto', objectFit: 'contain', display: 'block', flex: 'none' }}
    />
  );
}
